import _ from 'lodash';

const resetForm = (form, defaults) => {
    _.each(form, (formEl, key) => {
        if (_.isObject(formEl)) {
            if (defaults && defaults.hasOwnProperty(key)) {
                if (formEl.onChange) {
                    formEl.onChange(defaults[key]);
                } else {
                    resetForm(formEl, defaults[key]);
                }
            }
            else if (formEl.value) {
                if (_.isString(formEl.value)) {
                    formEl.onChange('');
                } else if (_.isNumber(formEl.value)) {
                    formEl.onChange('');
                } else if (_.isBoolean(formEl.value)) {
                    formEl.onChange(false);
                }
            } else {
                resetForm(formEl, defaults);
            }
        }
    });
};

export default resetForm;